import React from 'react';
import { useTheme } from 'contexts/ThemeProvider';

export const ThemeToggle = () => {
    const { theme, toggleTheme } = useTheme();

    return (
        <button
            onClick={() => {
                console.log('ThemeToggle: button clicked');
                toggleTheme();
            }}
            className="relative h-9 w-9 rounded-lg border border-slate-200 bg-white/80 text-slate-700 transition-all hover:bg-white hover:shadow-md dark:border-slate-700 dark:bg-slate-800/80 dark:text-slate-200 dark:hover:bg-slate-800"
            aria-label={theme === 'light' ? 'Включить темную тему' : 'Включить светлую тему'}
            title={theme === 'light' ? 'Включить темную тему' : 'Включить светлую тему'}
        >
            {/* Sun icon (shown in dark mode) */}
            <svg
                className={`absolute inset-0 m-auto h-5 w-5 transition-all ${theme === 'dark' ? 'rotate-0 scale-100 opacity-100' : 'rotate-90 scale-0 opacity-0'
                    }`}
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                strokeWidth={2}
            >
                <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M12 3v1m0 16v1m9-9h-1M4 12H3m15.364 6.364l-.707-.707M6.343 6.343l-.707-.707m12.728 0l-.707.707M6.343 17.657l-.707.707M16 12a4 4 0 11-8 0 4 4 0 018 0z"
                />
            </svg>

            {/* Moon icon (shown in light mode) */}
            <svg
                className={`absolute inset-0 m-auto h-5 w-5 transition-all ${theme === 'light' ? 'rotate-0 scale-100 opacity-100' : '-rotate-90 scale-0 opacity-0'
                    }`}
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                strokeWidth={2}
            >
                <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M20.354 15.354A9 9 0 018.646 3.646 9.003 9.003 0 0012 21a9.003 9.003 0 008.354-5.646z"
                />
            </svg>
        </button>
    );
};
